import { ChangeDetectorRef, EventEmitter, SimpleChanges, } from '@angular/core';
import { Store } from '@ngrx/store';
import { AUTOCOMPLETER_STATE_SLICE_KEY } from 'SearchApp/ts/features/base-autocomplete/state/autocompleter.reducer';
import { UrlsService } from 'NewAngular/services/core/urls.service';
import { abbreviateUserDisplayName } from 'NewAngular/features/components/navigation/utils';
import { SearchResultsBaseDirective } from 'SearchApp/ts/features/base-autocomplete/directives/search-results.directive';
import * as i0 from "@angular/core";
import * as i1 from "NewAngular/services/core/urls.service";
import * as i2 from "@ngrx/store";
import * as i3 from "@angular/common";
const _c0 = () => [];
function ImpersonationTargetUserListComponent_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function ImpersonationTargetUserListComponent_ng_template_2_For_1_Template(rf, ctx) { if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "label", 4)(1, "input", 5);
    i0.ɵɵlistener("change", function ImpersonationTargetUserListComponent_ng_template_2_For_1_Template_input_change_1_listener() { const user_r3 = i0.ɵɵrestoreView(_r2).$implicit; const ctx_r3 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r3.setCurrentTargetUserAutocomplete(user_r3)); });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(2, "span", 6);
    i0.ɵɵelementStart(3, "span", 7);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const user_r3 = ctx.$implicit;
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("checked", (ctx_r3.currentTargetUser == null ? null : ctx_r3.currentTargetUser.email) === user_r3.target_user_email);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r3.getUserDisplayName(user_r3.target_user_first_name, user_r3.target_user_last_name), " ");
} }
function ImpersonationTargetUserListComponent_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵrepeaterCreate(0, ImpersonationTargetUserListComponent_ng_template_2_For_1_Template, 5, 2, "label", 4, i0.ɵɵrepeaterTrackByIndex);
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵrepeater(ctx_r3.autocompleterTargetUserList || i0.ɵɵpureFunction0(0, _c0));
} }
function ImpersonationTargetUserListComponent_ng_template_4_For_1_Template(rf, ctx) { if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "label", 4)(1, "input", 5);
    i0.ɵɵlistener("change", function ImpersonationTargetUserListComponent_ng_template_4_For_1_Template_input_change_1_listener() { const user_r6 = i0.ɵɵrestoreView(_r5).$implicit; const ctx_r3 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r3.setCurrentTargetUser(user_r6)); });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(2, "span", 6);
    i0.ɵɵelementStart(3, "span", 7);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const user_r6 = ctx.$implicit;
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("checked", (ctx_r3.currentTargetUser == null ? null : ctx_r3.currentTargetUser.email) === user_r6.email);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r3.getUserDisplayName(user_r6.first_name, user_r6.last_name), " ");
} }
function ImpersonationTargetUserListComponent_ng_template_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵrepeaterCreate(0, ImpersonationTargetUserListComponent_ng_template_4_For_1_Template, 5, 2, "label", 4, i0.ɵɵrepeaterTrackByIndex);
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵrepeater(ctx_r3.initialTargetUserList || i0.ɵɵpureFunction0(0, _c0));
} }
/**
 * Impersonation Target User List Component
 *
 * Displays and manages a list of users that can be impersonated. The list can be the
 * initial target user list OR autocompleter results.
 */
export class ImpersonationTargetUserListComponent extends SearchResultsBaseDirective {
    constructor(changeDetector, urlsService, store) {
        super(urlsService, store);
        this.changeDetector = changeDetector;
        this.store = store;
        this.initialTargetUserList = [];
        this.currentTargetUser = null;
        this.setCurrentTargetUserHandler = new EventEmitter();
        this.autocompleterTargetUserList = [];
        this.showAutocompleterResults = false;
        this.mapStateToComponent = (state) => {
            const autocompleterState = state[this.autocompleterId];
            if (!autocompleterState) {
                return;
            }
            this.inputText = autocompleterState.inputText;
            this.autocompleterTargetUserList =
                autocompleterState.results;
            // We don't use autocompleterState.showResults because we want to show results when there's
            // input text and the field is focused, even if the results array is empty.
            this.showAutocompleterResults = this.inputText.length > 0 && !autocompleterState.blurred;
        };
        this.storeSubscription = this.store.select(AUTOCOMPLETER_STATE_SLICE_KEY).subscribe(this.mapStateToComponent);
    }
    ngOnChanges(changes) {
        if (changes.currentTargetUser?.currentValue) {
            this.changeDetector.detectChanges();
        }
    }
    ngOnDestroy() {
        this.storeSubscription.unsubscribe();
    }
    setCurrentTargetUser(user) {
        this.setCurrentTargetUserHandler.emit(user);
    }
    setCurrentTargetUserAutocomplete(result) {
        // dispatch action to set selected result in store
        this.clickResult();
        const currentTargetUser = {
            email: result.target_user_email,
            first_name: result.target_user_first_name,
            last_name: result.target_user_last_name,
        };
        this.setCurrentTargetUserHandler.emit(currentTargetUser);
    }
    getUserDisplayName(firstName, lastName) {
        return abbreviateUserDisplayName(firstName, lastName, 26);
    }
}
ImpersonationTargetUserListComponent.ɵfac = function ImpersonationTargetUserListComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || ImpersonationTargetUserListComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i1.UrlsService), i0.ɵɵdirectiveInject(i2.Store)); };
ImpersonationTargetUserListComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ImpersonationTargetUserListComponent, selectors: [["ycn-impersonation-target-user-list"]], inputs: { initialTargetUserList: "initialTargetUserList", currentTargetUser: "currentTargetUser" }, outputs: { setCurrentTargetUserHandler: "setCurrentTargetUserHandler" }, standalone: false, features: [i0.ɵɵInheritDefinitionFeature, i0.ɵɵNgOnChangesFeature], decls: 6, vars: 3, consts: [["autocompleterTargetUsers", ""], ["initialTargetUsers", ""], ["tabindex", "-1", 3, "mouseenter", "mouseleave"], [4, "ngIf", "ngIfThen", "ngIfElse"], [1, "custom-control", "custom-checkbox", "dropdown-item", "custom-checkbox-style1"], ["type", "checkbox", 1, "custom-control-input", 3, "change", "checked"], [1, "custom-control-indicator"], [1, "custom-control-description", 2, "text-overflow", "'.'", "white-space", "nowrap"]], template: function ImpersonationTargetUserListComponent_Template(rf, ctx) { if (rf & 1) {
        const _r1 = i0.ɵɵgetCurrentView();
        i0.ɵɵelementStart(0, "div", 2);
        i0.ɵɵlistener("mouseenter", function ImpersonationTargetUserListComponent_Template_div_mouseenter_0_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.setShouldBlur(false)); })("mouseleave", function ImpersonationTargetUserListComponent_Template_div_mouseleave_0_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.setShouldBlur(true)); });
        i0.ɵɵtemplate(1, ImpersonationTargetUserListComponent_ng_container_1_Template, 1, 0, "ng-container", 3);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(2, ImpersonationTargetUserListComponent_ng_template_2_Template, 2, 1, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor)(4, ImpersonationTargetUserListComponent_ng_template_4_Template, 2, 1, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        const autocompleterTargetUsers_r7 = i0.ɵɵreference(3);
        const initialTargetUsers_r8 = i0.ɵɵreference(5);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.showAutocompleterResults)("ngIfThen", autocompleterTargetUsers_r7)("ngIfElse", initialTargetUsers_r8);
    } }, dependencies: [i3.NgIf], encapsulation: 2 });
